import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/toDoTask'

export const toDoTaskService = {
    search,
    getItem,
    approveItem,
    rejectItem,
    editItem,
    getTaskByModel,
    approveAll,
    rejectAll,
};

function search(offset, max, data) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', data)
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function approveItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/approve/${id}`, 'POST');
}

function rejectItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/reject/${id}`, 'POST');
}

function editItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/edit/${id}`, 'POST');
}

function getTaskByModel(data) {
    return utilHelper.doRequest(`${relativeUrl}/getTaskByModel/`, 'POST', data);
}

function approveAll(data) {
    return utilHelper.doRequest(`${relativeUrl}/approveMultiples`, 'POST', data);
}

function rejectAll(data) {
    return utilHelper.doRequest(`${relativeUrl}/rejectMultiples`, 'POST', data);
}